// src/data/postsData.js
import chatGptImage from '../../../assets/images/postImages/chatgpt.png'
import aiImage from '../../../assets/images/postImages/aiImage.png'
import remoteWork from '../../../assets/images/postImages/remote.png'
import climate from '../../../assets/images/postImages/climate.jpg'
import rabbit from '../../../assets/images/postImages/rabbit.png'



const posts = [
  {
    id: "201",
    imageUrl: aiImage,
    date: "Posted on Aug 23 2025",
    dateRecent:" Aug 23, 2025",
    title: "AI Hype vs. AI Reality: Where Are We Really Heading?",
    description: "While generative AI tools are impressive, the real solution lies in grounding AI development with practical use-cases, better regulation, and transparent models rather than chasing hype or general intelligence fantasies.",
    detailedDescription: "Generative AI has captured the world's attention, but expectations must be realistic. The key lies in applying AI to solve practical, everyday challenges. Regulation is critical to ensure safe and fair progress. Transparency in how models work will build trust. We need focus over fantasy to move forward responsibly."
  },
  {
    id: "202",
    imageUrl: chatGptImage,
    date: "Posted on Aug 15 2025",
    dateRecent:"Aug 15, 2025",
    title: "OpenAI vs. Google vs. Anthropic: The AI Race Unpacked",
    description: "This race is fueling rapid innovation, but the solution is not just faster models — it’s responsible deployment, open collaboration, and putting alignment with human values over market dominance.",
    detailedDescription: "Tech giants are in a sprint for AI dominance, pushing capabilities further each month. But with great power comes great responsibility. Faster models aren't enough — responsible rollout matters more. Aligning AI goals with human ethics and safety is essential. True progress lies in collaboration, not just competition."
  },
  {
    id: "203",
    imageUrl: remoteWork,
    date: "Posted on Jul 30 2025",
    dateRecent:"Jul 30, 2025",
    title: "Remote Work Is Changing — Not Ending",
    description: "Instead of returning fully to offices or staying remote, the balanced solution is a hybrid model with flexible work hours, async tools, and clear outcome-based goals — not physical presence.",
    detailedDescription: "The future of work isn’t binary — it’s adaptive. Hybrid models combine the best of office culture and remote flexibility. Success depends on clear goals, not hours logged at desks. Async communication and outcome-driven workflows are key. What matters now is effectiveness, not presence."
  },
  {
    id: "204",
    imageUrl: climate,
    date: "Posted on Jul 20 2025",
    dateRecent:"Jul 20, 2025",
    title: "Can Tech Really Solve Climate Change?",
    description: "Yes — but only if we shift from overconsumption to green innovation, invest in sustainable infrastructure like smart grids and EVs, and hold tech companies accountable for their carbon footprints.",
    detailedDescription: "Technology offers tools to fight climate change, but it’s not a silver bullet. We must reduce wasteful practices and drive innovation toward sustainability. Investment in renewables, smart energy systems, and EVs is essential. Tech companies must be held accountable for their emissions. It’s time for green transformation, not just talk."
  },
  {
    id: "205",
    imageUrl: rabbit,
    date: "Posted on Aug 10 2025",
    dateRecent:"Aug 10, 2025",
    title: "Humane AI Pin, Rabbit R1 & the Post-Smartphone Future",
    description: "Wearable AI devices are exciting, but the solution isn’t to replace smartphones — it’s to build context-aware, privacy-first AI companions that enhance daily life without being intrusive.",
    detailedDescription: "Smartphone alternatives are emerging, but replacing phones isn't the goal. Instead, we need AI devices that are smart, respectful, and intuitive. Context-awareness and data privacy must guide their design. The focus should be on enhancing how we interact with technology. Innovation should feel natural, not forced."
  }
];

export default posts;
